import React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

export const themeObj = {
	palette: {
		primary: {
			main: '#006fd9',
		},
		secondary: {
			main: '#014c94',
			dark: '#003567',
		},
		background: {
			default: '#D5E6F8',
		},
		payment: {
			main: '#15b940',
			dark: '#15b940',
		},
		red: '#fb2f2f',
		green: '#15b940',
		orange: '#d89300',
		pink: '#930766',
		purple: '#d3c1fc',
		black: 'rgba(0, 0, 0, 0.87)',
		lightGrey: 'rgb(160, 160, 160)',
		yellow: 'rgb(255, 244, 228)',
		darkerYellow: 'rgb(213, 146, 44)',
	},
	typography: {
		useNextVariants: true,
	},
	overrides: {
		MuiTooltip: {
			tooltip: {
				fontSize: 16,
			},
		},
	},
}

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme(themeObj)

function withRoot(Component) {
	function WithRoot(props) {
		// MuiThemeProvider makes the theme available down the React tree
		// thanks to React context.
		return (
			<MuiThemeProvider theme={theme}>
				{/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
				<CssBaseline />
				<Component {...props} />
			</MuiThemeProvider>
		)
	}

	return WithRoot
}

export default withRoot
